// Cinematic interior-page hero banner (static, bold Playfair heading)
export default function PageHero({ overline, title, subtitle, image }) {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section data-testid="page-hero" className="relative flex h-[62vh] min-h-[440px] items-end overflow-hidden">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" loading="eager" />
      <div className="absolute inset-0 bg-gradient-to-t from-forest/92 via-forest/45 to-forest/40" />
      <div className="relative z-10 mx-auto w-full max-w-[1400px] px-5 pb-16 md:px-10 md:pb-20">
        {overline && <p className="mb-4 text-sm uppercase tracking-widest-2 text-champagne md:text-base">{overline}</p>}
        <h1 className="font-display text-5xl font-bold leading-[0.98] tracking-tight text-ivory [text-shadow:0_2px_24px_rgba(0,0,0,0.35)] sm:text-6xl md:text-7xl">
          {lines.map((l, i) => (
            <span key={i} className="block">{l}</span>
          ))}
        </h1>
        {subtitle && <p className="mt-6 max-w-xl text-base text-ivory/85 md:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
